import { render, staticRenderFns } from "./wx_auth.vue?vue&type=template&id=429aa04b&scoped=true&"
import script from "./wx_auth.vue?vue&type=script&lang=js&"
export * from "./wx_auth.vue?vue&type=script&lang=js&"
import style0 from "./wx_auth.vue?vue&type=style&index=0&id=429aa04b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429aa04b",
  null
  
)

export default component.exports